// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Bookmark as RawBookmark } from "lucide-react";
export const Bookmark = /* @__PURE__ */ createIcon(RawBookmark, "Bookmark", 2);
